<template>
	<div class="h-panel-body padding font-bold">
		<div class="h-panel-bar"><span class="h-panel-title">现金银行日记账</span></div>

		<div class="topselectbox">
			<div class="topselect02">
                账号：<a-select :value="actId"  v-model="actId" style="width:200px;padding-right:5px;" :options="actSelectData" @change="loadList" > </a-select>
                时间：<a-range-picker :locale="locale" v-model="dp" @change="onTimeChange" /> &nbsp;
                <button class="h-btn " @click="loadList">查询</button> 
                <button class="h-btn h-btn-blue" @click="showDrawer">新增</button> 
				<button class="h-btn h-btn-blue" @click="generateVoucherHandle">生成凭证</button> 
				<button class="h-btn h-btn-blue" @click="unbindVoucherHandle">解除关联凭证</button> 
				<button class="h-btn" @click="getExportTemplate">导出模版</button>
				<Button :loading="loading" @click="doUpload">
					<input ref="file" type="file" accept="application/vnd.ms-excel" style="display: none" @change="fileChange($event)">
					导入
				</Button>
				<Button :loading="loading" @click="doUpload2">
					<input ref="file2" type="file" accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" style="display: none" @change="yqImport($event)">
					亿企导入
				</Button>
				
                <!-- <button class="h-btn h-btn-blue" @click="getTemplate()">导出模版<button> -->

            </div>
		</div>

		<div class="tablebox">

			<Table :datas="datas" :height="650" :border="true" ref="table" stripe checkbox @select="onTbSelect">
				<TableItem title="序号"  :width="35"><template slot-scope="{index}">{{index+1}}</template></TableItem>
				<TableItem title="日期" prop="billTime" :width="90" />
				<TableItem title="摘要" align="center" prop="abstractName" :width="100" />
                <!-- <TableItem title="出纳编号" prop="cashierNo" align="center" :width="100" /> -->
                <TableItem title="结算方式" prop="settlementTypeName" align="center" :width="100" />
				<TableItem title="收支方向"   align="center" :width="80" >
                    <template #default="{ data }"> 
						<span   >
                            {{  data.direction==1 ?"收入" : data.direction==2 ?"支出":"-" }}</span> 
					</template>
                </TableItem>
                <TableItem title="出纳编号" prop="cashierNo" align="center" :width="100" />
                <TableItem title="票据日期" prop="paperTime" align="center" :width="80" />
                <TableItem title="票号" prop="paperNo" align="center" :width="100" />
                <TableItem title="借(收入)金额" prop="incomeAmount" align="center" :width="90" />
                <TableItem title="贷(支出)金额" prop="payAmount" align="center" :width="90" />
				<TableItem title="账户余额" prop="actAfterAmount" align="center" :width="90" />
				<!-- <TableItem title="借贷方向" prop="amountDirection" align="center" :width="70" /> -->
                <TableItem title="经手人" prop="handlePersonName" align="center" :width="80" />
                <TableItem title="对方科目" prop="oppositeSubjectName" align="center" :width="100" />
                <TableItem title="操作人" prop="personName" align="center" :width="100" />
                <TableItem title="是否关联凭证"   align="center" :width="100" >
                    <template #default="{ data }"> 
						<span   > {{  data.bindVoucherId!=undefined &&  data.bindVoucherId>0   ? "是" : "否" }}</span> &nbsp;

							<router-link v-if="data.bindVoucherId!=undefined &&  data.bindVoucherId>0 && data.voucherCode!=undefined" style="color:rgb(45, 123, 244);cursor: pointer;"
								tag="span" :to="{name:'VoucherForm',params:{voucherId:data.bindVoucherId}}">{{"["+data.voucherCode+"]"}}</router-link>
					</template>
                </TableItem> 
				<TableItem title="备注" prop="remark" align="center" :width="90" />
				<TableItem title="操作" :width="100" align="center">
					<template #default="{ data }">
						<span style="color:#2d7bf4; cursor: pointer;" @click="showDrawer(data)">编辑</span> &nbsp;&nbsp;
                        <span style="color:#2d7bf4; cursor: pointer;" @click="del(data.id)">删除</span>
					</template>
				</TableItem>
				
				<template #empty>
					自定义提醒：暂时无数据
				</template>
			</Table>
            <br/>
            <Pagination v-model="pagination" @change="currentChange" layout="pager" small align="center"/>
            <!-- <div class="yema" v-show="datas.length>0">
				<a-pagination
					v-model="current"
					:total="total"
					:page-size="pageSize">
					<template slot="buildOptionText" slot-scope="props">
					<span v-if="props.value !== '50'">{{ props.value }}条/页</span>
					<span v-if="props.value === '50'">全部</span>
					</template>
				</a-pagination>
			</div> -->
		</div>
 

		<a-drawer title="编辑设置" width="50%" :closable="false" :visible="visible" @close="onClose">

			<div class="fiveeditbox">
                <table width="100%">
					<tr>
                        <td width="50%">
                            <span>*收支方向：</span>
                            <a-radio-group v-model:value="showdata.direction" button-style="solid" @change="directionChange">
								<a-radio-button :value="1">收入</a-radio-button>
								<a-radio-button :value="2">支出</a-radio-button> 
							</a-radio-group>
                        </td>
                        <td width="50%">
                             
                        </td>
                    </tr>
                    <tr>
                        <td width="50%">
                            <span>*日期：</span>
                            <DatePicker  style="width:70%" v-model="showdata.billTime" :format="'YYYY-MM-DD'"></DatePicker>
                        </td>
                        <td width="50%">
                            <span>*摘要：</span>
                            <a-input placeholder="摘要" :value="showdata.abstractName" v-model="showdata.abstractName" style="width:53%" />
                            <a-button style="margin-left: 3px" @click="showAbs">摘要</a-button>
                        </td>
                    </tr>
                    <tr>
                        <td width="50%">
                            <span>出纳编号：</span>
                            <a-input placeholder="出纳编号" :value="showdata.cashierNo" v-model="showdata.cashierNo" disabled />
                        </td>
                        <td width="50%">
                            <span>结算方式：</span>
                            <a-select :value="showdata.settlementType"  v-model="showdata.settlementType" style="width:70%" 
                                :options="stSelectData" show-search :filter-option="filterOption" allowClear> </a-select>
                            <!-- <a-input placeholder="结算方式" :value="showdata.settlementType" v-model="showdata.settlementType"   /> -->
                        </td>
                    </tr>
                     <tr>
                        <td width="50%">
                            <span>票据日期：</span>
                            <DatePicker  style="width:70%" v-model="showdata.paperTime" :format="'YYYY-MM-DD'"></DatePicker>
                        </td>
                        <td width="50%">
                            <span>票号：</span>
                            <a-input placeholder="票号" :value="showdata.paperNo" v-model="showdata.paperNo"   />
                        </td>
                    </tr>
					<tr>
                        <td width="50%">
                            <span>对方户名：</span>
                            <a-input placeholder="对方户名" :value="showdata.accountName" v-model="showdata.accountName"   />
                        </td>
                        <td width="50%">
                            <span>对方账户：</span>
                            <a-input placeholder="对方账户" :value="showdata.accountNumber" v-model="showdata.accountNumber"   />
                        </td>
                    </tr>
                     <tr>
                        <td width="50%">
                            <span>借(收入)额：</span>
                            <a-input-number placeholder="借(收入)金额" :value="showdata.incomeAmount" v-model="showdata.incomeAmount" :min="0" :disabled="showdata.direction==2" style="width:70%" />
                        </td>
                        <td width="50%">
                            <span>贷(支出)额：</span>
                            <a-input-number placeholder="贷(支出)金额" :value="showdata.payAmount" v-model="showdata.payAmount" :disabled="showdata.direction==1" :min="0" style="width:70%"/>
                        </td>
                    </tr>
                     <tr>
                        <td width="50%">
                            <span>经手人：</span>
                            <a-input placeholder="经手人" :value="showdata.handlePersonName" v-model="showdata.handlePersonName"   />
                        </td>
                        <td width="50%">
                            <span>对方科目：</span>
                            <a-select v-model="showdata.oppositeSubjectId" :options="subjectData"  style="width:280px"
							show-search :filter-option="filterOption" :allowClear='true'></a-select>
                        </td>
                    </tr>
					<tr> 
                        <td width="50%">
                            <span>操作人：</span>
                            <a-input placeholder="操作人" :value="showdata.personName" v-model="showdata.personName"  disabled />
                        </td>
                        <td width="50%">
                            <span>收支类型：</span>
                             <a-select v-model="showdata.tradeTypeId" :options="tradeTypeData"  style="width:280px"
							show-search :filter-option="filterOption" :allowClear='true'></a-select>
                        </td>
                    </tr>
                     <tr>
                        <td colspan="2" width="100%">
                            <span>备注：</span>
                            <a-input placeholder="备注" :value="showdata.remark" v-model="showdata.remark" style="width:85%"  />
                        </td> 
                    </tr>
                </table> 
			</div>

			<div :style="{
				position: 'absolute',
				bottom: 0,
				width: '100%',
				borderTop: '1px solid #e8e8e8',
				padding: '10px 16px',
				textAlign: 'right',
				left: 0,
				background: '#fff',
				borderRadius: '0 0 4px 4px',
			}">
				<a-button style="marginRight: 8px" @click="onClose">
					取消
				</a-button>
				<a-button type="primary" @click="onSave">
					确定
				</a-button>
			</div>
		</a-drawer>
 
        <a-modal title="选择摘要" :visible="showAbstract"  cancelText="取消" okText="确认"
         @ok="showAbstract=false"  @cancel="showAbstract=false">
			<Table :datas="absList" :border="true"  :height="600" >
				<TableItem title="编码">
					<template slot-scope="{data}">
						<span :style="{paddingLeft:(data.isRoot?1:2)*15+'px'}">{{data.code}}</span>
					</template>
				</TableItem>
				<TableItem title="名称" prop="name"></TableItem> 
				<TableItem title="操作" :width="80" align="center">
					<div class="actions" slot-scope="{data}">
						<span @click="absRowClick(data.name)" >选择</span> 
					</div>
				</TableItem>
			</Table>
		</a-modal>

		<a-modal title="生成凭证" :visible="generateVoucherVisible"  cancelText="取消" okText="确认" width="560px"
         @ok="generateVoucherSubmit()"  @cancel="generateVoucherVisible=false">
			<div class="dv_gv">
				<span>生成规则：</span>
				<Radio v-model="generateForm.roles" :datas="generateRoles"></Radio>
			</div> 
			<div class="dv_gv">
				<span>科目合并：</span>
				<Checkbox v-model="generateForm.mergeBankStateA" :value="1">合并银行科目</Checkbox> &nbsp;
				<Checkbox v-model="generateForm.mergeOppositeSubjectStateA" :value="1">合并对方科目</Checkbox>
			</div>  
		</a-modal>

	</div>
</template>

<script>
import locale from 'ant-design-vue/es/date-picker/locale/zh_CN';
import Qs from "qs";
import moment from 'moment'
import { mapState } from 'vuex'
import 'moment/locale/zh-cn';

export default {
	name: "Salarymanage",
    watch: {
			checkAll(nval) {
				let data = Array.from(this.datas);
				data.forEach(val => val._checked = nval);
				this.datas = data;
			},
			accountDate() {
				this.pagination.page = 1;
				this.loadList();
			}
		},
	data() {
		return {
            current: 1, //页码
			pageSize: 50,
			total: 50,
            pagination: {
                page: 1, 
                size:50,
                total: 0
            },
            generateForm:{
				roles:1,
				mergeBankState:false,
				mergeOppositeSubjectState:false,
				mergeBankStateA:[],
				mergeOppositeSubjectStateA:[],
				actId:undefined,
				accountSetsId:undefined,
				cashDailyList:[]
			},
			generateRoles:[
				{ title: '每条记录对应一张凭证', key: '1' }, { title: '相同收支类型对应一张凭证', key: '3' }
			],
            actId:0,
			dataList: {},
            absList:[],
			datas: [], 
			visible: false,
            showAbstract:false,
			hildrenDrawer: false,
            actData:[],
			loading:false,
            voucherSelect: [],
            SettlementTypeList:[],
            stSelectData:[],
            actSelectData:[],
			subjectData:[],
			tradeTypeData:[],
			tradeTypeData1:[],
			tradeTypeData2:[],
			selectRowList:[],
			generateVoucherVisible:false,
            kmFiler: "",
			showdata: {
				name: '',
				id: '',
				actId: '',
				status: 1
			},
            startTime:undefined,
            endTime:undefined,
            locale,
			dp:[]
		}
	},
	computed: {
		...mapState(['User', 'currentAccountSets']),
		date() {
			return moment(this.accountDate);
		}
	},
	created() {  
		this.loadList();
        this.subjectLoad();
		this.actLoad();
        this.absListLoad();
		this.tradeTypeLoad();
        this.settlementTypeLoad();
	},
	mounted() {
        
	},
	methods: {
        loadList() { 
			if(this.startTime==undefined ||this.startTime=='' || this.endTime==undefined || this.endTime==''){
				this.startTime =moment().startOf("month").format("YYYY-MM-DD");
				this.endTime = moment().endOf("month").format("YYYY-MM-DD");
				this.dp = [
					this.startTime,
					this.endTime
				];
			}
			var accountSetsId = this.User.accountSetsId;
            var that = this;
            if(this.actId==undefined||this.actId ==0){
                this.$api.cashier.act_list(accountSetsId).then(({ data }) => { 
                    if(data!=undefined && data.length>0){
                        for(var i = 0;i<data.length;i++){
                            var ops = {
                                value:data[i].id,
                                label:data[i].name
                            }
                            this.actSelectData.push(ops);
                        } 
                        this.actId= data[0].id;
                    }
                });
            }
            
            if(this.startTime=='' || this.endTime==''){
                var parmas = { 
                    accountSetsId:accountSetsId,
                    actId:this.actId,
                    current:this.pagination.page,
                    size:this.pagination.size
                } 
            }else{
                var parmas = { 
                    accountSetsId:accountSetsId,
                    actId:this.actId,
                    current:this.pagination.page,
                    size:this.pagination.size,
                    startTime:this.startTime,
                    endTime:this.endTime
                }  
            }
 
			this.$api.cashier.cd_list(parmas).then(({ data }) => { 
                 
                    this.datas= data.records;
                    this.current = data.current;
                    this.total = data.total;
                    this.pagination = {
						page: data.current,
						size: data.size,
						total: data.total
					}
           
                
				  
			})
		},
        filterOption(input, option) {
            return (
                option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
            );
        },
        absListLoad(){
            if(this.absList==undefined||this.absList.length==0){
                var accountSetsId = this.User.accountSetsId;
                this.$api.cashier.abs_list(accountSetsId).then(({data}) => {
                    this.absList = data || []; 
                });
            }
        },
		tradeTypeLoad(){
			if(this.tradeTypeData1==undefined || this.tradeTypeData1.length==0){
				var params={
					accountSetsId : this.User.accountSetsId,
					type:1
				}
				this.$api.cashier.trade_list(params).then(({data}) => {
					 
					if(data!=undefined && data.length>0){
						for(var i = 0;i<data.length;i++){
							var ops = {
								value:data[i].id,
								label:data[i].code+'-'+data[i].name
							}
							this.tradeTypeData1.push(ops);
						}
					} 
                });
			}
			if(this.tradeTypeData2==undefined|| this.tradeTypeData2.length==0){
				var params={
					accountSetsId : this.User.accountSetsId,
					type:2
				}
				this.$api.cashier.trade_list(params).then(({data}) => {
                    if(data!=undefined && data.length>0){
						for(var i = 0;i<data.length;i++){
							var ops = {
								value:data[i].id,
								label:data[i].code+'-'+data[i].name
							}
							this.tradeTypeData2.push(ops);
						}
					}  
                });
			}
		},
        showAbs(){
            this.showAbstract=true;
        },
        absRowClick(absName){
            this.showdata.abstractName = absName;
            this.showAbstract=false;
        },
        settlementTypeLoad(){
            var accountSetsId = this.User.accountSetsId;
            this.$api.cashier.sett_list(accountSetsId).then(({ data }) => { 
				this.SettlementTypeList = data;	
                if(this.SettlementTypeList!=undefined && this.SettlementTypeList.length>0){
                    for(var i = 0;i<this.SettlementTypeList.length;i++){
                        var ops = {
                            value:this.SettlementTypeList[i].id,
                            label:this.SettlementTypeList[i].name
                        }
                        this.stSelectData.push(ops);
                    } 
                }
			})
        }, 
        actLoad() {
            var accountSetsId = this.User.accountSetsId;
            this.$api.cashier.act_list(accountSetsId).then(({data}) => {
                console.log(data);
                this.voucherSelect = data;	
                if(this.voucherSelect!=undefined && this.voucherSelect.length>0){
                    for(var i = 0;i<this.voucherSelect.length;i++){
                        var ops = {
                            value:this.voucherSelect[i].id,
                            label:this.voucherSelect[i].name
                        }
                        this.actData.push(ops);
                    }
                    console.log(this.actData)
                    // var ops = {
                    //     value=
                    // }
                }
                // console.log(this.voucherSelect)
            });
        },
		subjectLoad() { 
				this.$api.setting.subject.voucherSelect({showAll: true}).then(({data}) => {
					var voucherSelect = data;	
					if(voucherSelect!=undefined && voucherSelect.length>0){
						for(var i = 0;i<voucherSelect.length;i++){
							var ops = {
								value:voucherSelect[i].id,
								label:voucherSelect[i].subjectFullName
							}
							this.subjectData.push(ops);
						}
					}
				});
			},
		//时间筛选
        onTimeChange(date, dateString){
            this.startTime = dateString[0];
            this.endTime = dateString[1];
            this.loadList();
        },

		showDrawer(data) {
			this.visible = true; 
            if(data==undefined || data.id==undefined){
                this.showdata={
					direction:1,
                    status:1
                };
				this.tradeTypeData=this.tradeTypeData1
            }else{
				if(data.direction==1){
					this.tradeTypeData=this.tradeTypeData1;
				}else{
					this.tradeTypeData=this.tradeTypeData2;
				}
			    this.showdata = data; 
				
            }
		},
        currentChange(){
            this.loadList();
        },
		directionChange(){
			if(this.showdata.direction==1){
				this.showdata.payAmount=0;
				this.showdata.tradeTypeId=undefined;
				this.tradeTypeData=this.tradeTypeData1;
			}else if (this.showdata.direction==2){
				this.showdata.incomeAmount=0;
				this.showdata.tradeTypeId=undefined;
				this.tradeTypeData=this.tradeTypeData2;
			}
		},
		onClose() {
			this.visible = false;
		},
		onSave() {
			var showdata = this.showdata;
			showdata.accountSetsId = this.User.accountSetsId;
			var that = this;
            showdata.actId =this.actId;
 
			if(showdata.id!=undefined){
				this.$api.cashier.cd_edit(showdata).then(data => {
					if (data.code == 200) {
						that.loadList();
						this.$message.success('编辑成功');
						this.visible = false;
					} else {
						this.$message.error('编辑失败');
					}
				})
			}else{
				this.$api.cashier.cd_add(showdata).then(data => {
					if (data.code == 200) {
						that.loadList();
						this.$message.success('添加成功');
						this.visible = false;
					} else {
						this.$message.error('添加失败');
					}


				})
			}
 

		},
        del(id) {
				this.$Confirm("确认删除?").then(() => {
					this.$api.cashier.cd_del(id).then(() => {
						this.loadList();
					})
				})
			},
		onTbSelect(data, event) {
			console.log(data);
			
			this.selectRowList.forEach(item=>{
				if(item.bindVoucherId!=undefined && item.bindVoucherId > 0){
					 this.$refs.table.setRowSelect(item)
				} 
			})
			this.selectRowList=data;
			
		},
		showChildrenDrawer() {
			this.childrenDrawer = true;
		},
		onChildrenDrawerClose() {
			this.childrenDrawer = false;
		},
		//生成凭证
		generateVoucherHandle(){
			
			//判断是否选中记录
			if(this.selectRowList.length==0){
				this.$Message("请选择记账记录");
				return ;
			}
			//判断选中记录是否已生成凭证
			var selectData = new Array();
			this.selectRowList.forEach(item=>{
				if(item.bindVoucherId==undefined ||  item.bindVoucherId == 0){
					selectData.push(item);
				}
			})
			if(selectData.length>0){
				this.$refs.table.setSelection(selectData); 
			}else{
				this.$refs.table.clearRowSelect();
				this.$refs.table.setSelection([]);
			}
			this.generateForm = {
				actId:this.actId,
				accountSetsId:this.User.accountSetsId,
				cashDailyList:selectData,
				roles:1
			};
			if(selectData.length>0){
				this.generateVoucherVisible=true;
			} 
			else {
				this.$Message("请选择未关联凭证的记账记录");
			}
		},
		generateVoucherSubmit(){
			var params = this.generateForm;
			params.mergeBankState = this.generateForm.mergeBankStateA !=undefined && this.generateForm.mergeBankStateA.length>0?true:false;
			params.mergeOppositeSubjectState = this.generateForm.mergeOppositeSubjectStateA !=undefined && this.generateForm.mergeOppositeSubjectStateA.length>0?true:false;
			console.log(params)
			this.$api.voucher.generateVoucher(params).then(data =>{
				console.log(data)
				if (data.code == 200) {
						this.loadList();
						this.$message.success('生成成功');
						this.generateVoucherVisible = false;
					} else {
						this.$message.error(data.msg);
					}
			})
			
		},
        getExportTemplate(){ 
            this.$api.exportExcel.cashDailyTemplate() 
				.then(data => {
					let objectUrl = window.URL.createObjectURL(new Blob([data]))
					const link = document.createElement('a')
					link.download = '日记账模板.xls'
					link.href = objectUrl
					link.click()
				}
			);
        },
		doUpload() {
			this.$refs.file.click();
		},
		doUpload2() {
			this.$refs.file2.click();
		},
		fileChange(e) {
			if (this.$refs.file.files.length) {
				let formData = new FormData();
				formData.append('file', this.$refs.file.files[0]);
				formData.append('accountSetsId',this.User.accountSetsId);
				formData.append('actId',this.actId);
				this.loading = true;
				this.$api.exportExcel.cashDailyImport(formData).then(({data}) => {
					this.$Message("亲,导入成功~");
					this.loadList();
				}).finally(() => {
					this.loading = false;
				});
				this.$refs.file.value = "";
			}
		},
		yqImport(){
			if(this.actId){ 
				if (this.$refs.file2.files.length) {
					let formData = new FormData();
					formData.append('file', this.$refs.file2.files[0]);
					formData.append('accountSetsId',this.User.accountSetsId);
					formData.append('actId',this.actId);
					this.loading = true;
					this.$api.cashier.yqImport(formData).then(({data}) => {
						this.$Message("亲,导入成功~");
						this.loadList();
					}).finally(() => {
						this.loading = false;
					});
					this.$refs.file.value = "";
				}
			}else{
				this.$Message("请选择账号")
			}
			
		},
		//解除关联凭证
		unbindVoucherHandle(){
			//判断是否选中记录
			if(this.selectRowList.length==0){
				this.$Message("请选择记账记录");
				return ;
			}
			
			this.$Confirm("确认取消关联凭证?").then(() => {
				var selectData = new Array();
				this.selectRowList.forEach(item=>{
					if(item.bindVoucherId!=undefined && item.bindVoucherId > 0){
						selectData.push(item.id);
					}
				})
				this.$api.cashier.unbindVoucherBatch(selectData).then(data =>{
					console.log(data)
					if (data.code == 200) {
						this.loadList();
						this.$message.success('解绑成功'); 
					} else {
						this.$message.error(data.msg);
					}
				})
			})
		}

	},
	mounted() {

	}
}
</script>


<style lang="less" scoped>
.h-row>div>div {
	padding: 8px;
	border-radius: 5px;
	text-align: center;
	font-size: 20px;
	color: #000;
}

.period {
	border-radius: 3px;
	text-align: center;
	line-height: 54px;
	border: 1px solid @primary-color;
	white-space: nowrap;
	overflow: hidden;
	box-sizing: border-box;
	height: 80px;

	&:hover {
		cursor: pointer;
		box-shadow: 0 0 20px 2px rgba(102, 100, 100, 0.24), 0px 2px 4px 0px rgba(199, 198, 198, 0.5);
	}

	.month-header {
		height: 25px;
		margin: -8px -8px 0 -8px;
	}

	&.completed {
		.month-header {
			background-color: @gray1-color !important;
			line-height: 20px;
		}

		border-color: @gray1-color;

		color: #a2a2a2;

		&:hover {
			cursor: default;
			box-shadow: none;
		}
	}

	&.disable {
		opacity: 0.4;

		&:hover {
			cursor: default;
			box-shadow: none;
		}
	}
}

.topselectbox {}

.topselectbox .topselect02 {
	padding-top: 15px;
	padding-left: 20px;
}

.tablebox {
	padding-left: 20px;
	padding-top: 20px;
}

.fiveeditbox {
	width: 800px;
	margin: 0 auto;
}

.fiveeditbox ul li {}

.fiveeditbox ul li p {
	font-size: 15px;
	padding-bottom: 5px;
	padding-top: 10px;
}
.fiveeditbox table tr td span {
	font-size: 15px; 
    line-height: 31px;
    display:inline-block;
    width:90px;
}
.fiveeditbox table tr td input {
	width:70%; 
}
.fiveeditbox table tr{
    height:70px;
}
.yemabox {
	padding-top: 50px;
	padding-bottom: 30px;
}
.yema{ text-align:center; padding-top:30px;}
.dv_gv{
	padding: 20px;
}
</style>
